import { render, staticRenderFns } from "./qiyeDetail.vue?vue&type=template&id=4fc4e795&scoped=true&"
import script from "./qiyeDetail.vue?vue&type=script&lang=js&"
export * from "./qiyeDetail.vue?vue&type=script&lang=js&"
import style0 from "./qiyeDetail.vue?vue&type=style&index=0&id=4fc4e795&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc4e795",
  null
  
)

export default component.exports